import React, {useState} from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Close from "./images/close.svg";
import Modal from "../../shared/modal";
import CheckCircle from "./images/check-circle.svg";
import { FILTER_KEYS } from "../../../constants/app-constants";
import { getPageSectionByName } from "../../../utils/helpers/get-cms-section";
const SellerTypeInfo = ({
    isOpen = true,
    onClose = () => {},
    activeTab = FILTER_KEYS.CARS24,
    globalCmsConfig = {}
}) => {

    const {pageSections: cmsSections = []} = globalCmsConfig || {};
    const sellerTypeInfoSectionData = getPageSectionByName(cmsSections, "SELLER_TYPE_MODAL");
    const {meta: {
        data = {}
    } = {}
    } = sellerTypeInfoSectionData || {};
    const {
        cards = []
    } = data || {};
    const [selectedCategory, setSelectedCategory] = useState(cards.find(tab => tab.key === activeTab) || cards[0]);
    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
    };
    if (!cards?.length) {
        return null;
    }
    return (
        <Modal isOpen={isOpen}>
            <div styleName={"styles.outer"}>
                <div styleName={"styles.headerWrap"}>
                    <p styleName={"styles.heading"}>{selectedCategory?.heading || "Your car, Your Choice"}</p>
                    <img onClick={onClose} src={Close} />
                </div>
                <div styleName={"styles.contentWrap"}>
                    <div styleName={"styles.tabsWrapper"}>
                        {(cards || []).map((tab = {}) => (
                            <div style={{backgroundColor: tab.bgColor}} styleName={`styles.tab ${selectedCategory.key === tab.key ? "styles.activeTab" : ""}`} onClick={() => handleCategoryClick(tab)}>
                                <img src={tab?.background} alt="bg" styleName={"styles.tabBackground"} />
                                <img src={tab?.logo} alt ="logo" styleName="styles.tabLogo"/>
                                <p styleName={"styles.tabHeading"}>{tab.highlightTitle}</p>
                                <p styleName={"styles.tabSubheading"}>{tab.subTitle}</p>
                            </div>
                        ))}
                    </div>
                    <div styleName={"styles.featuresWrapper"}>
                        <p styleName={"styles.description"}>{selectedCategory?.highlightDescription}</p>
                        <p styleName={"styles.featureHeading"}>{selectedCategory?.offers?.offersHeading}</p>
                        <ul>
                            {selectedCategory?.offers?.offerItems?.map((feature) => (
                                <li styleName={"styles.featureItem"}>
                                    <img src={CheckCircle} />
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

SellerTypeInfo.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    activeTab: PropTypes.string,
    globalCmsConfig: PropTypes.object
};

export default SellerTypeInfo;
